module.exports = __webpack_public_path__ + "img/9-white.07ad59bd.png";